import apiInstance from "../api";
import { getResFromJWTToken } from "../utils/decodeJWTRes";

export const updateUserProfile = async (data: any) => {
  try {
    const response = await apiInstance.put("/auth/update-user-profile", data);

    const resData: any = getResFromJWTToken(response?.data);

    return resData;
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getUserProfile = async (token: string) => {
  try {
    const { data } = await apiInstance.get(`user/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const fetchReviewData = async (token: string) => {
  try {
    const { data } = await apiInstance.get(`review/user`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const addReviewData = async (
  id: string,
  addData: any,
  token: string
) => {
  try {
    const { data } = await apiInstance.post(`/review/course/${id}`, addData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const updateReviewData = async (
  id: string,
  updateData: any,
  token: string
) => {
  try {
    const { data } = await apiInstance.put(`review/${id}`, updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const deleteReviewData = async (id: string, token: string) => {
  try {
    const { data } = await apiInstance.delete(`review/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const getDashboardData = async (token: string) => {
  try {
    const { data } = await apiInstance.get(`/course/student-dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const getStudentCourseData = async (token: string) => {
  try {
    const { data } = await apiInstance.get(`/course/enrolled`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const getStudentOrderHistory = async (token: string) => {
  try {
    const { data } = await apiInstance.get(`/user/payment-history`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};
